import { render, staticRenderFns } from "./carta-de-servicos.vue?vue&type=template&id=7e47320a&scoped=true"
import script from "./carta-de-servicos.vue?vue&type=script&lang=js"
export * from "./carta-de-servicos.vue?vue&type=script&lang=js"
import style0 from "./carta-de-servicos.vue?vue&type=style&index=0&id=7e47320a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e47320a",
  null
  
)

export default component.exports